import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_input = _resolveComponent("app-input")!
  const _component_app_select = _resolveComponent("app-select")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    ref: "formRef",
    as: "el-form",
    "validation-schema": _ctx.schema
  }, {
    default: _withCtx(() => [
      _createVNode(_component_app_input, {
        modelValue: _ctx.handle,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.handle) = $event)),
        name: "handle",
        label: _ctx.$localize('profile.edit.handle'),
        placeholder: _ctx.$localize('profile.edit.add.handle'),
        enterkeyhint: "done",
        onOnEnter: _ctx.onEnter
      }, null, 8, ["modelValue", "label", "placeholder", "onOnEnter"]),
      _createVNode(_component_app_select, {
        modelValue: _ctx.handleSpeciality,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.handleSpeciality) = $event)),
        name: "specialities",
        label: _ctx.$localize('profile.edit.specialities'),
        placeholder: _ctx.$localize('profile.edit.add.specialities'),
        options: _ctx.mainStore.specialities
      }, null, 8, ["modelValue", "label", "placeholder", "options"]),
      _createVNode(_component_app_input, {
        modelValue: _ctx.profileStore.bufferProfile.bio,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.profileStore.bufferProfile.bio) = $event)),
        name: "bio",
        label: _ctx.$localize('profile.edit.bio'),
        placeholder: _ctx.$localize('profile.edit.add.bio')
      }, null, 8, ["modelValue", "label", "placeholder"])
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}